import { CategoryEnum } from './category';

export enum SubCategoryEnum {
    apartment = 'Apartment',
    house = 'House',
    townhouse = 'Townhouse',
    unit = 'Unit'
}

export enum LifeStyleSubCategoryEnum {
    bareland = 'Bareland',
    dwelling = 'Dwelling',
}

export const NEW_HOME_SUB_CATEGORIES: ReadonlyMap<CategoryEnum, string> =
    new Map<CategoryEnum, string>([
        [CategoryEnum.newHomesNewApartment, 'Apartment'],
        [CategoryEnum.newHomesNewTownhouseAndTerraced, 'Townhouse'],
        [CategoryEnum.newHomesHouseAndLand, 'House'],
        [CategoryEnum.newHomesNewHouse, 'House']
    ]);

export const SECTIONS_FOR_SALE_SUB_CATEGORIES: ReadonlyMap<CategoryEnum, string> =
    new Map<CategoryEnum, string>([
        [CategoryEnum.sectionsForSale, 'Section']
    ]);

export const RURAL_SUB_CATEGORIES = [
    'BareLand',
    'Cropping',
    'Dairy',
    'Deer',
    'Forestry',
    'HighCountry',
    'Horticulture',
    'Mixed',
    'SheepBeef'
];
